import React from 'react';
import { DashboardLayout } from '@/components/layouts/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { BookOpen, TrendingUp, Building2, Lightbulb } from 'lucide-react';

const Industry = () => {
    return (
        <DashboardLayout>
            <div className="space-y-8">
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="text-3xl font-bold">Industry Insights</h1>
                        <p className="text-gray-600 mt-1">
                            Discover what employers are looking for
                        </p>
                    </div>
                </div>

                <Card className="bg-gradient-to-br from-interview-blue/10 to-interview-teal/10 border-2 border-interview-blue/20">
                    <CardHeader>
                        <div className="flex items-center gap-3">
                            <div className="w-12 h-12 rounded-full bg-interview-blue/20 flex items-center justify-center">
                                <TrendingUp className="w-6 h-6 text-interview-blue" />
                            </div>
                            <div>
                                <CardTitle className="text-2xl">Coming Soon</CardTitle>
                                <CardDescription className="text-base">
                                    We're building something exciting!
                                </CardDescription>
                            </div>
                        </div>
                    </CardHeader>
                    <CardContent className="space-y-8">
                        <p className="text-lg text-gray-700">
                            Our Industry Insights feature will help you understand the skills and qualifications that are most in-demand in your field. Stay tuned for:
                        </p>

                        <div className="grid gap-6 md:grid-cols-2">
                            <div className="flex items-start gap-4">
                                <div className="w-10 h-10 rounded-full bg-interview-teal/20 flex items-center justify-center shrink-0">
                                    <Building2 className="w-5 h-5 text-interview-teal" />
                                </div>
                                <div>
                                    <h3 className="font-medium text-lg">Industry Trends</h3>
                                    <p className="text-gray-600 mt-1">
                                        Real-time data on which skills and qualifications are most requested by employers in your industry
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="w-10 h-10 rounded-full bg-interview-orange/20 flex items-center justify-center shrink-0">
                                    <BookOpen className="w-5 h-5 text-interview-orange" />
                                </div>
                                <div>
                                    <h3 className="font-medium text-lg">Learning Paths</h3>
                                    <p className="text-gray-600 mt-1">
                                        Personalized recommendations for courses and resources to help you acquire in-demand skills
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="w-10 h-10 rounded-full bg-purple-200 flex items-center justify-center shrink-0">
                                    <Lightbulb className="w-5 h-5 text-purple-600" />
                                </div>
                                <div>
                                    <h3 className="font-medium text-lg">Career Insights</h3>
                                    <p className="text-gray-600 mt-1">
                                        Expert advice and market analysis to help you make informed career decisions
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="w-10 h-10 rounded-full bg-green-200 flex items-center justify-center shrink-0">
                                    <TrendingUp className="w-5 h-5 text-green-600" />
                                </div>
                                <div>
                                    <h3 className="font-medium text-lg">Salary Insights</h3>
                                    <p className="text-gray-600 mt-1">
                                        Up-to-date salary ranges and compensation trends for different roles and experience levels
                                    </p>
                                </div>
                            </div>
                        </div>

                        <p className="text-gray-600 text-center pt-4">
                            We're working hard to bring you these features. Check back soon for updates!
                        </p>
                    </CardContent>
                </Card>
            </div>
        </DashboardLayout>
    );
};

export default Industry; 